import React from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { FontFamilies } from "@/constants/Typography";
import { UserBill } from "@/types/bill";
import dayjs from "dayjs";

type Props = {
  bill: UserBill;
  onPress: () => void;
};

export const BillItem: React.FC<Props> = ({ bill, onPress }) => {
  return (
    <TouchableOpacity style={styles.billItem} onPress={onPress}>
      <View style={styles.billHeader}>
        <View style={styles.billInfo}>
          <Text style={styles.billProvider}>{bill.provider}</Text>
          <Text style={styles.billType}>
            {bill.billType.charAt(0).toUpperCase() + bill.billType.slice(1)}{" "}
            Bill
          </Text>
        </View>
        <Text style={styles.billAmount}>
          {bill.currency} {bill.totalAmount.toFixed(2)}
        </Text>
      </View>

      <View style={styles.billDetails}>
        <View style={styles.detailRow}>
          <Text style={styles.detailLabel}>Account:</Text>
          <Text style={styles.detailValue}>{bill.accountNumber}</Text>
        </View>
        <View style={styles.detailRow}>
          <Text style={styles.detailLabel}>Billing Date:</Text>
          <Text style={styles.detailValue}>
            {dayjs(bill.billingDate).format("MMM DD, YYYY")}
          </Text>
        </View>
        {bill.invoiceNumber && (
          <View style={styles.detailRow}>
            <Text style={styles.detailLabel}>Invoice:</Text>
            <Text style={styles.detailValue}>{bill.invoiceNumber}</Text>
          </View>
        )}
        {bill.billId && (
          <View style={styles.detailRow}>
            <Text style={styles.detailLabel}>Bill ID:</Text>
            <Text style={styles.detailValue}>{bill.billId}</Text>
          </View>
        )}
        <View style={styles.detailRow}>
          <Text style={styles.detailLabel}>Due Date:</Text>
          <Text style={styles.detailValue}>
            {dayjs(bill.dueDate).format("MMM DD, YYYY")}
          </Text>
        </View>
        <View style={styles.detailRow}>
          <Text style={styles.detailLabel}>Period:</Text>
          <Text style={styles.detailValue}>
            {dayjs(bill.billingPeriod.startDate).format("MMM DD")} -{" "}
            {dayjs(bill.billingPeriod.endDate).format("MMM DD, YYYY")}
          </Text>
        </View>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  billItem: {
    backgroundColor: "#FFFFFF",
    borderRadius: 12,
    padding: 16,
  },
  billHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 12,
  },
  billInfo: {
    flex: 1,
  },
  billProvider: {
    fontSize: 16,
    fontFamily: FontFamilies.InterTight.SemiBold,
    color: "#1F2937",
  },
  billType: {
    fontSize: 12,
    fontFamily: FontFamilies.Inter.Regular,
    color: "#6B7280",
    marginTop: 2,
  },
  billAmount: {
    fontSize: 18,
    fontFamily: FontFamilies.InterTight.Bold,
    color: "#0F9129",
  },
  billDetails: {
    borderTopWidth: 1,
    borderTopColor: "#E5E7EB",
    paddingTop: 12,
  },
  detailRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 6,
  },
  detailLabel: {
    fontSize: 12,
    fontFamily: FontFamilies.Inter.Regular,
    color: "#6B7280",
  },
  detailValue: {
    fontSize: 12,
    fontFamily: FontFamilies.Inter.Medium,
    color: "#374151",
  },
});
